module.exports = __webpack_public_path__ + "img/podium.bdc8b324.jpg";